import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import { SITE } from '../data/site';
import { usePageMeta } from '../hooks/usePageMeta';

// ---------------------------------------------------------------------------
// CONTACT FORM — disabled until a Web3Forms key is configured.
// To re-enable:
//   1. Get a free key at web3forms.com and set REACT_APP_WEB3FORMS_KEY
//      (see company/.env.example; local: .env.local, prod: Cloudflare Pages env).
//   2. Uncomment the two imports below and the <ContactForm> block in the JSX.
//   3. Swap the "contact-cards-grid" layout back to the "contact-layout"
//      split (form left, cards right) if you want the original design.
// ---------------------------------------------------------------------------
// import { useMemo } from 'react';
// import { useSearchParams } from 'react-router-dom';
// import ContactForm from '../components/ContactForm';

function Contact() {
  usePageMeta({
    title: 'Contact | EightyThreeLabs',
    description:
      'Get in touch with EightyThreeLabs. Book a free 15-minute call or email us — we reply within one business day.',
  });

  // Prefills the service select from links like /contact?service=AI%20Automation.
  // const [searchParams] = useSearchParams();
  // const defaultService = useMemo(() => searchParams.get('service') ?? undefined, [searchParams]);

  return (
    <Layout>
      <PageHeader
        eyebrow="CONTACT"
        title="Let's talk about the outcome you need."
        description={`We respond to every inquiry within ${SITE.responseTime}. No sales pitch, just a conversation.`}
      >
        <div className="cta-buttons">
          <a href={SITE.calendly} target="_blank" rel="noopener noreferrer" className="btn-primary">
            Book a Free 15-min Call
          </a>
          <a href={`mailto:${SITE.contact.email}`} className="btn-secondary">
            Email Us
          </a>
        </div>
      </PageHeader>

      <section className="section section-white">
        <div className="container">
          {/*
          <div className="contact-layout-form reveal" id="contact-form">
            <ContactForm defaultService={defaultService} />
          </div>
          */}

          <div className="contact-cards-grid reveal">
            <a
              href={SITE.calendly}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-info-card"
            >
              <div className="contact-info-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </div>
              <div className="contact-info-text">
                <span className="contact-info-label">Book a call</span>
                <span className="contact-info-value">Free 15-min consultation</span>
              </div>
              <span className="contact-info-arrow">&rarr;</span>
            </a>

            <a href={`mailto:${SITE.contact.email}`} className="contact-info-card">
              <div className="contact-info-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 6l-10 7L2 6" />
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                </svg>
              </div>
              <div className="contact-info-text">
                <span className="contact-info-label">Email</span>
                <span className="contact-info-value">{SITE.contact.email}</span>
              </div>
              <span className="contact-info-arrow">&rarr;</span>
            </a>

            <a
              href={SITE.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-info-card"
            >
              <div className="contact-info-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="20"
                  height="20"
                  aria-hidden="true"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zM7.119 20.452H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </div>
              <div className="contact-info-text">
                <span className="contact-info-label">LinkedIn</span>
                <span className="contact-info-value">EightyThreeLabs</span>
              </div>
              <span className="contact-info-arrow">&rarr;</span>
            </a>
          </div>

          <div className="contact-reassure contact-reassure-wide reveal reveal-delay-1">
            <p>
              Not sure which service fits? Book the call anyway — 15 minutes is usually enough to
              tell you whether automation makes sense for your workflow, and what it would take.
              Based in {SITE.location.city}, {SITE.location.region} — {SITE.location.serving}.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Contact;
